import { ApolloProvider } from '@apollo/client';
import type { AppProps } from 'next/app';

import { useApollo } from 'apollo-client';

import AppContainer from 'containers/app';
import LoadingContainer from 'containers/loading';

import { ErrorBoundary } from 'components/layout/ErrorBoundary';

import { setupDayjsConfig } from 'utils/dates';

import 'styles/globals.css';

interface IProps extends AppProps {
  Component: any; // TODO: навесить тип
}

setupDayjsConfig();

const layouts: any = {
  app: AppContainer,
  loading: LoadingContainer,
};

function MyApp({ Component, pageProps }: IProps) {
  const apolloClient = useApollo(pageProps);
  const componentLayout = Component.layout;
  const Layout = componentLayout ? layouts[componentLayout] : layouts['app'];

  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <Layout>
          <Component {...pageProps} />
        </Layout>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default MyApp;
